export default __webpack_public_path__ + "static/media/threat_analy.c0bea7e4.png";